import { IconButton, IconButtonProps } from '@components/icon-button';
import { IconReplace } from '@components/icons/replace';
import { useScopedTranslate } from '@locale/translate';

import { showReplaceActionModal } from 'ui/journey-builder/create-action/add-action-modal';

type ConvertButtonProps = Pick<IconButtonProps, 'size'> & {
  journeyActionShortId: string;
};

export const ConvertButton = ({ journeyActionShortId, ...rest }: ConvertButtonProps) => {
  const { t } = useScopedTranslate(locale);

  return (
    <IconButton
      icon={<IconReplace />}
      aria-label={t('convert')}
      variant="ghost-purple"
      stopPropagation
      onClick={() => showReplaceActionModal({ replaceActionId: journeyActionShortId })}
      {...rest}
    />
  );
};

const locale = {
  en: {
    convert: 'Convert',
  },
};
